const localeSelector = (state) => state.ui.locale.locale;

export default localeSelector;



/** WEBPACK FOOTER **
 ** ./app/selectors/localeSelector.js
 **/